import { useEffect, useState } from 'react'
import { API_BASE_URL } from '../data'

/**
 * Hook to fetch and access global settings
 * @param key - The setting key to fetch
 * @returns Object with value, loading state, and error
 */
export const useGlobalSetting = <T>(key: string) => {
    const [value, setValue] = useState<T | null>(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState<string | null>(null)

    useEffect(() => {
        const fetchSetting = async () => {
            setLoading(true)
            setError(null)

            try {
                const response = await fetch(`${API_BASE_URL}/settings/key/${key}`, {
                    credentials: 'include',
                    headers: {
                        'Accept': 'application/json'
                    }
                })

                if (!response.ok) {
                    throw new Error('Setting not found')
                }

                const result = await response.json()
                setValue(result.value)
            } catch (err) {
                setError(err instanceof Error ? err.message : 'Failed to fetch setting')
                setValue(null)
            } finally {
                setLoading(false)
            }
        }

        fetchSetting()
    }, [key])

    return { value, loading, error }
}

/**
 * Hook specifically for the visit_announced flag
 */
export const useVisitAnnounced = () => {
    return useGlobalSetting<boolean>('visit_announced')
}

/**
 * Hook specifically for the show_shift_info flag
 */
export const useShowShiftInfo = () => {
    return useGlobalSetting<boolean>('show_shift_info')
}
